import React, {ReactNode} from 'react'

import {Card} from '../../UI/index.js'
import {controlCardStyle} from '../styles.js'

/** A card of map buttons (MapControlButton) in a map's toolbar, stacked below each other */
export default function MapControlCard({children}: {children?: ReactNode}) {
    return (
        <Card shadow style={controlCardStyle}>
            {children}
        </Card>
    )
}
